import React, {useEffect, useState, useRef} from "react";
import {Grid, Box, Typography} from "@material-ui/core";
import MessageItem from "./MessageItem";
import {makeStyles, Theme} from "@material-ui/core/styles";

interface Props {
    messages: any[];
    names?: any,
    isVet?: boolean
    isVideo?: boolean
}

const useStyle = makeStyles((theme: Theme) => ({
    container: {
        height: "80vh",
        bgcolor: "#fff",
        marginTop: "10vh",
        padding: "20px",
        borderRadius: "20px",
        marginBottom: "20px",
        maxHeight: "80vh",
        overflowY: "scroll"
    },
}));

const vetStyle = makeStyles((theme: Theme) => ({
    container: {
        height: "70vh",
        bgcolor: "#fff",
        marginTop: "10vh",
        padding: "20px",
        borderRadius: "20px",
        marginBottom: "20px",
        maxHeight: "70vh",
        overflowY: "scroll"
    },
}));
const videoChatStyle = makeStyles((theme: Theme) => ({
    container: {
        height: "calc(100% - 80px)",
        minHeight: 150,
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "20px",
        marginTop: "20px",
        overflowY: "scroll",
        [theme.breakpoints.down("sm")]: {
            height: "70vh",
            backgroundColor: "#fff",
            marginTop: "10vh",
            padding: "20px",
            borderRadius: "20px",
            marginBottom: "20px",
            maxHeight: "70vh",
        }
    },
}));

const MessageList = ({messages, names, isVet, isVideo = false}: Props) => {
    const classes = useStyle();
    const vetClasses = vetStyle();
    const videoClasses = videoChatStyle();

    const end = useRef(null);
    useEffect(() => {
        end.current.scrollIntoView({behavior: "smooth", block: "end"});
    }, [messages]);

    return (
        <Box className={isVet ? vetClasses.container : isVideo ? videoClasses.container : classes.container}>
            {
                //@ts-ignore
                messages.length ? [...new Set(messages)].map(({authorId, message, eventName}, index) => {
                    let author;
                    if ([
                        "Chat is no longer active. Please request a new chat appointment if you need additional advice. Thanks!",
                        "make user redirect ${true}",
                        "The veterinary provider has re-opened the chat.",
                    ].includes(message) || eventName === "NOTIFICATION") {
                        author = "Admin";
                    } else {
                        author = names[authorId];
                    }
                    return (
                        <MessageItem author={author || "User"} body={message} key={index}/>
                    );
                }) :
                    <MessageItem author="Admin" body="No messages sent."/>
            }
            <div ref={end} style={{float: "left", clear: "both"}}></div>
        </Box>
    );
};

export default MessageList;
